import Inputmask from 'inputmask'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        'mask': String,
    }

    connect() {
        Inputmask(this.mask, { placeholder: '', clearMaskOnLostFocus: true }).mask(this.element);
    }

    disconnect() {
        Inputmask.remove(this.element)
    }

    get mask () {
        try {
            return JSON.parse(this.maskValue)
        } catch (error) {
            return this.maskValue
        }
    }
}